<template>
  <el-dialog
    :title="title"
    :visible.sync="dialogVisible"
    width="70%"
    top="2vh"
    append-to-body>
    <div v-loading="contentLoading" class="body">
      <el-row>
        <el-col :span="6">
          <label>{{$t("elevator.no")}} ：</label><span>{{potentialFaultStatTp.elevatorNo}}</span>
        </el-col>
        <el-col :span="6">
          <label>{{$t("elevator.name")}} ：</label><span>{{potentialFaultStatTp.elevatorName}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <label>{{$t("potentialFault.potentialFaultName")}}
            ：</label><span>{{potentialFaultStatTp.potentialFaultName}}</span>
        </el-col>
        <el-col :span="5">
          <label>{{$t("potentialFault.totalPoints")}} ：</label><span>{{potentialFaultStatTp.totalPoints}}</span>
        </el-col>
        <el-col :span="5">
          <label>{{$t("potentialFault.warningValue")}} ：</label><span>{{potentialFaultStatTp.warningValue}}</span>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <label>{{$t("common.beginTime")}} ：</label><span>{{potentialFaultStatTp.beginTime}}</span>
        </el-col>
        <el-col :span="6">
          <label>{{$t("common.endTime")}} ：</label><span>{{potentialFaultStatTp.endTime}}</span>
        </el-col>
      </el-row>
      <el-row>
        <vm-table
          ref="vmTable"
          :table-data="tableData"
          :total="total"
          :loading="loading"
          :show-add="false"
          :show-toolbar="false"
          :current-page="currentPage"
          @page-change="changePage">
          <el-table-column prop="faultCode" :label="$t('potentialFault.faultCode')" width="100px"></el-table-column>
          <el-table-column prop="faultDesc" :label="$t('potentialFault.faultDesc')" width="250px"></el-table-column>
          <el-table-column prop="weight" :label="$t('potentialFault.weight')"></el-table-column>
          <el-table-column prop="faultCount" :label="$t('potentialFault.faultCount')"></el-table-column>
          <el-table-column :label="$t('potentialFault.faultOccurrenceTime')" width="240">
            <template slot-scope="scope">
              <el-button @click="handleClick(scope.row.faultCode)">{{$t("common.detail")}}</el-button>
              <potential-fault-time ref="potentialFaultTime"></potential-fault-time>
            </template>
          </el-table-column>
        </vm-table>
      </el-row>
    </div>
  </el-dialog>
</template>
<script>
  import VmTable from "../../components/VmTable.vue";
  import PotentialFaultTime from "./PotentialFaultTime.vue";

  const moduleName = "potentialFaults";

  export default {
    components: {VmTable, PotentialFaultTime},
    data() {
      return {
        dialogVisible: false,
        loading: false,
        contentLoading: false,
        currentPage: 1,
        total: 0,
        dataTimes: "",
        elevatorId: "",
        potentialFaultSettingId: "",
        beginTime: "",
        potentialFaultStatTp: {
          elevatorNo: "",
          elevatorName: "",
          totalPoints: "",
          potentialFaultName: "",
          warningValue: "",
          beginTime: "",
          endTime: "",
        },
        tableData: [],
      };
    },
    computed: {
      title() {
        return this.$t("potentialFault.potentialFaultDetails");
      },
    },
    methods: {
      open(pro) {
        this.dialogVisible = true;
        this.elevatorId = pro.elevatorId;
        this.potentialFaultSettingId = pro.potentialFaultSettingId;
        this.beginTime = pro.beginTime;
        this.getData();
        this.getList(1);
      },
      getData() {
        this.contentLoading = true;
        let params = {
          "elevatorId": this.elevatorId,
          "potentialFaultSettingId": this.potentialFaultSettingId,
          "beginTime": this.beginTime,
        };
        this.$api.getData(moduleName + "/faultDetail", params).then(res => {
          this.potentialFaultStatTp = res.data;
          this.contentLoading = false;
        }).catch((error) => {
          this.contentLoading = false;
          if (error.response) {
            this.$message.error(this.$t("common.tip.getDataError") + error.response.data.message);
          }
        });
      },
      getList(pageIndex) {
        this.currentPage = pageIndex;
        this.loading = true;
        let params = {
          "pageIndex": pageIndex,
          "elevatorId": this.elevatorId,
          "potentialFaultSettingId": this.potentialFaultSettingId,
          "beginTime": this.beginTime,
        };
        this.$api.getData(moduleName + "/faultDetails", params).then(res => {
          this.loading = false;
          let data = res.data;
          this.tableData = data.list;
          this.total = data.total;
        }).catch((error) => {
          this.loading = false;
          if (error.response) {
            this.$message.error(this.$t("common.tip.getDataError") + error.response.data.message);
          }
        });
      },
      changePage(pageIndex) {
        this.getList(pageIndex);
      },
      handleClick(faultCode) {
        this.$refs.potentialFaultTime.open(this.elevatorId, faultCode, this.potentialFaultStatTp.beginTime, this.potentialFaultStatTp.endTime);
      },
    },
  };
</script>
<style lang="scss" scoped>
</style>
